import { create } from "zustand";

// Bump-counter store used to force the Create page (vision/plan) back to its
// default state when the user clicks the "Create" nav link, even if they're
// already on the page. The PlanRoute wrapper keys on `nonce`, so each bump
// remounts the route and resets all its internal useState/useReducer state.

interface CreatePageResetState {
  nonce: number;
  bump: () => void;
}

export const useCreatePageReset = create<CreatePageResetState>((set) => ({
  nonce: 0,
  bump: () => set((s) => ({ nonce: s.nonce + 1 })),
}));
